import axios from "axios";
import { URLS } from "../config";
import { logoutHandler } from "./logoutHandler";
import { toast } from "react-toastify";

interface Props {
  token: string;
  dispatch: any;
  navigate: any;
  setLoading: (value: boolean) => void;
  setProductsCategoryData: (value: any) => void;
  setBannersData: (value: any) => void;
  setCarouselData: (value: any) => void;
  setBrandData: (value: any) => void;
  setProductsTopSellsData: (value: any) => void;
}

export const getHomePageData = async ({
  token,
  dispatch,
  navigate,
  setLoading,
  setProductsCategoryData,
  setBannersData,
  setCarouselData,
  setBrandData,
  setProductsTopSellsData,
}: Props) => {
  setLoading(true);

  try {
    const res = await axios.get(URLS.GET_HOME_PAGE, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    });

    const home_page_infos = res.data;

    setProductsCategoryData(home_page_infos.all_categories);
    setBannersData(home_page_infos.banners);
    setCarouselData(home_page_infos.banners); // اگر متفاوت است اصلاح کن
    setBrandData(home_page_infos.brands);
    setProductsTopSellsData(home_page_infos.new_products);
    if (! home_page_infos.site_is_available){
      toast.error(" در حال حاضر امکان ثبت سفارش نمیباشد.");
    }

  } catch (error: any) {
    if (error.response?.status === 401) {
      toast.error("برای ادامه لطفاً وارد حساب کاربری شوید");
      logoutHandler(dispatch, navigate);
    } else {
      toast.error("خطا در دریافت اطلاعات صفحه اصلی");
    }
  } finally {
    setLoading(false);
  }
};